// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multiselect[data-v-4a0cb86f] {\n  min-width: 300px;\n}\n.date-range-picker[data-v-4a0cb86f] {\n  max-width: 350px;\n}", ""]);
// Exports
module.exports = exports;
